module.exports = __webpack_public_path__ + "img/simonds.d03fc2e8.png";